import React, { useEffect, useState } from 'react'
import PrintersApp, { IPrinterModel } from './PrintersApp'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { Avatar, Button, IconButton, Skeleton } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import { LoadingButton } from '@mui/lab'

interface IPrintersListProps {
    handleOnClick: (printer: IPrinterModel) => void,
    printingLoaing?: boolean,
}

interface IOnlinePrinterProps extends IPrinterModel {
    handleOnClick: (printer: IPrinterModel) => void,
    printingLoaing?: boolean,
}

export function OnlinePrinter(props: IOnlinePrinterProps){

    const {
        name,
        printer_model,
        printer_key,
        thumbnail,
        location_title,
        location_id,
        handleOnClick,
        printingLoaing
    } = props

    return(
        <div className="single-transcation-order">
            <div className="content-of-single-transcation-order">


                <div className="boxes-of-single-transcation-order">
                    <div className="content-of-boxes-of-single-transcation-order">

                        <div className="info-box-of-single-transcation-order" style={{ maxWidth: 50, minWidth: 50 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <Avatar src={thumbnail} style={{ width: 50, height: 50 }}>
                                    <GenerateIcon icon="image" />
                                </Avatar>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Printer:</h3>
                                <p>{name}</p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Model:</h3>
                                <p>{printer_model}</p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Location:</h3>
                                <p>{location_title}</p>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="buttons-of-single-transcation-order">
                    <div className="content-of-buttons-of-single-transcation-order">
                            
                        <LoadingButton style={{ height: 45 }} loading={printingLoaing} className="general-button" color="success" variant="text" onClick={() => handleOnClick(props)}>Print</LoadingButton>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default function PrintersList(props: IPrintersListProps) {

    const dispatch = useDispatch()

    const {
        handleOnClick,
        printingLoaing,
    } = props

    const printersApp = new PrintersApp()

    const [printers, setPrinters] = useState<IPrinterModel[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const loadPrinters = () => {
        setLoading(true)

        printersApp.onlinePrintersList()
            .then(response => {
                const { data } = response

                setPrinters(data)
                setLoading(false)
            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })
    }

    /**
     * Load printers
     */
    useEffect(() => {
        loadPrinters()
    }, [])

    /**
     * Render refresh button
     */
    const renderRefreshButton = () => {
        if (loading){
            return <></>
        }

        return(
            <div style={{marginTop: 10, display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Button className="general-buton" startIcon={<GenerateIcon icon="refresh" />} onClick={() => loadPrinters()}>Refresh</Button>
            </div>
        )
    }

    /**
     * Render printers
     */
    const renderPrinters = () => {
        if (loading){
            return(
                <>
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                </>
            )
        }

        if (printers.length > 0){
            return printers.map((printer, index) => <OnlinePrinter {...printer} key={index} handleOnClick={handleOnClick} printingLoaing={printingLoaing} />)
        }

        return <p>No online printers found</p>
    }

    return(
        <div className="printers-list-container">
            <div className="content-of-printers-list-container">
                {renderPrinters()}
                {renderRefreshButton()}
            </div>
        </div>
    )
}